import { Badge } from "@/components/ui/badge";
import { getStatusBadgeConfig } from "@/lib/status-badges";
import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  type: string;
  status: string;
  className?: string;
}

export function StatusBadge({ type, status, className }: StatusBadgeProps) {
  const config = getStatusBadgeConfig(type, status);
  return (
    <Badge variant="outline" className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
}
